'use strict';

const helper = require('../../helper');
const paymentMethodGeneralHelper = require('../../paymentMethodGeneralHelper');

const newVenmoOptionEl = document.getElementById('newVenmoAccount');
const venmoAccountsListEl = document.getElementById('braintreeVenmoAccountsList');

/**
 * Returns an inner text of billing selector depends on conditions
 * @returns {string} Inner text
 */
const getBillingAddressSelectorInnerText = () => {
    const isEnrichedCustomerDataEnabled = newVenmoOptionEl?.getAttribute('data-is-enriched-customer-data-enabled') === 'true';
    const billingSelectorMessages = helper.tryParseJSON(newVenmoOptionEl?.getAttribute('data-billing-selector-messages'));

    return !isEnrichedCustomerDataEnabled && newVenmoOptionEl?.selected
        ?   billingSelectorMessages.BILLING_ADDRESS_SELECTOR_FROM_SHIPPING_TEXT
        :   billingSelectorMessages.BILLING_ADDRESS_SELECTOR_GENERAL_TEXT;
};

/**
 * Handles the behavior of the saveBillingAddressCheckbox
 * @param {boolean} showEl Whether show or hide
 */
const handleSaveBillingAddressCheckbox = showEl => {
    const checkboxEl = document.getElementById('saveVenmoBillingAddressContainer');

    helper.toggleElementVisibility(checkboxEl, showEl);
};

/**
 * The call back function to handle the value change of the saveBillingAddressCheckbox
 * @param {Object} event Change event object
 */
const onSaveBillingAddressCheckboxChange = event => {
    const infoEl = document.querySelector('.js-venmo-billing-address-info-alert');

    event.target.value = event.target.checked;
    helper.toggleElementVisibility(infoEl, event.target.checked);
};

/**
 * Handles the functionality that is depends on the saved billing address
 */
const handleSavedBillingAddressFunctionality = () => {
    const selectedOptionEl = helper.getSelectedOption(venmoAccountsListEl);
    const isBillingAddress = selectedOptionEl.dataset.billingAddress !== 'null';

    handleSaveBillingAddressCheckbox(!isBillingAddress);

    // Sets billing address from storefront
    if (!isBillingAddress) {
        const address = require('base/checkout/address');
        const venmoBillingInputEl = document.getElementById('braintreeVenmoBilling');
        const billingForm = document.getElementById('dwfrm_billing');

        venmoBillingInputEl.value = JSON.stringify(address.methods.getAddressFieldsFromUI(billingForm));
    }

    isBillingAddress
        ? paymentMethodGeneralHelper.disableBillingAddressFunctionality()
        : paymentMethodGeneralHelper.enableBillingAddressFunctionality();
};

/**
 * Whether the billing address message should be presented in billingAddressSelector
 * @returns {boolean} True/false
 */
const isBillingAddressMessage = () => {
    const selectedOptionEl = helper.getSelectedOption(venmoAccountsListEl);

    return !selectedOptionEl.dataset.billingAddress ? true
        : selectedOptionEl.dataset.billingAddress !== 'null';
};

module.exports = {
    getBillingAddressSelectorInnerText,
    handleSaveBillingAddressCheckbox,
    onSaveBillingAddressCheckboxChange,
    handleSavedBillingAddressFunctionality,
    isBillingAddressMessage
};
